// Períodos del reporte de incidencias: semanas de lunes a domingo (numeradas según ISO 8601),
// meses de calendario o un rango libre. Todo en fechas locales, como el resto de BLI.
import { fromApiDate, toApiDate } from "../../Insights/CounterInsights/Incidents/incidentPeriodPresets";

export const REPORT_MODES = ["week", "month", "custom"];

const addDays = (date, days) => new Date(date.getFullYear(), date.getMonth(), date.getDate() + days);

export const startOfWeek = (date) => addDays(new Date(date.getFullYear(), date.getMonth(), date.getDate()), -((date.getDay() + 6) % 7));

export const startOfMonth = (date) => new Date(date.getFullYear(), date.getMonth(), 1);

// Número de semana ISO: la semana 1 es la que contiene el primer jueves del año
export const getIsoWeek = (date) => {
  const thursday = addDays(startOfWeek(date), 3);
  const firstThursday = addDays(startOfWeek(new Date(thursday.getFullYear(), 0, 4)), 3);
  return { week: Math.round((thursday - firstThursday) / (7 * 24 * 60 * 60 * 1000)) + 1, year: thursday.getFullYear() };
};

// Por defecto se reporta la última semana completa, que es lo que se revisa cada lunes
export const defaultAnchor = (mode, today = new Date()) =>
  mode === "month" ? startOfMonth(today) : addDays(startOfWeek(today), -7);

export const shiftAnchor = (mode, anchor, steps) =>
  mode === "month"
    ? new Date(anchor.getFullYear(), anchor.getMonth() + steps, 1)
    : addDays(anchor, steps * 7);

export const getModeRange = (mode, anchor) => {
  if (mode === "month") {
    return { dateFrom: toApiDate(anchor), dateTo: toApiDate(new Date(anchor.getFullYear(), anchor.getMonth() + 1, 0)) };
  }
  return { dateFrom: toApiDate(anchor), dateTo: toApiDate(addDays(anchor, 6)) };
};

// No se avanza a un período que todavía no empezó
export const canGoForward = (mode, anchor, today = new Date()) => shiftAnchor(mode, anchor, 1) <= today;

const languageLocale = () => {
  try {
    return { es: "es", pt: "pt-BR", en: "en-US" }[localStorage.getItem("language")] || "en-US";
  } catch {
    return "en-US";
  }
};

export const formatMonth = (anchor) => {
  const label = new Intl.DateTimeFormat(languageLocale(), { month: "long", year: "numeric" }).format(anchor);
  return label.charAt(0).toUpperCase() + label.slice(1);
};

// Fecha y hora tal como están guardadas en la base: el driver las entrega como UTC sin serlo
export const formatDbDateTime = (value) => {
  if (!value) return "—";
  return new Intl.DateTimeFormat(languageLocale(), {
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
    timeZone: "UTC",
  }).format(new Date(value));
};

export const formatDuration = (hours) => {
  if (hours == null) return "—";
  const total = Math.floor(hours);
  const days = Math.floor(total / 24);
  return days > 0 ? `${days} d ${total % 24} h` : `${total} h`;
};

export const daysBetween = (dateFrom, dateTo) => Math.round((fromApiDate(dateTo) - fromApiDate(dateFrom)) / (24 * 60 * 60 * 1000)) + 1;
